<template>

    <v-card
		color="brightBackground"
		flat
		tile
        height="100%"
	>

        <v-container fluid style="max-width: 1000px;">

            <!-- Form -->
            <v-form ref="newProjectForm">

            <v-row>

                <v-col
                    align="center"
                    justify="center"
                >
                    <v-row no-gutters>
                        <v-subheader class="display-1 font-weight-bold pl-3 mt-5 ml-0 mb-3 pb-5 grey--text text--darken-3">Create project</v-subheader>
                    </v-row>

                    <v-row no-gutters>

                        <v-col cols="8" xs="12" sm="12" md="8" xl="8" class="px-3">
                            <v-text-field
                                label="Project name"
                                v-model="projectData.name"
                                :rules="agile.fieldRules.nameRules"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col cols="4" xs="12" sm="12" md="4" xl="4" class="px-3">
                            <v-select
                                v-model="group"
                                :items="groups"
                                item-text="tempName"
                                item-value="id"
                                :rules="agile.fieldRules.requiredRule"
                                label="Project group"
                                outlined
                                dense
                                return-object
                            ></v-select>
                        </v-col>

                    </v-row>


                    <v-row no-gutters>

                        <v-col cols="6" xs="12" sm="12" md="8" xl="8" class="px-3">
                            <v-text-field
                                label="Project safe name (for use with variables, urls etc.)"
                                v-model="projectData.variable"
                                :rules="agile.fieldRules.variableRules"
                                outlined
                                dense
                                
                            ></v-text-field>
                        </v-col>

                        <v-col cols="6" xs="12" sm="12" md="4" xl="4" class="px-3">
                            <v-text-field
                                label="Project prefix name"
                                v-model="projectData.prefix"
                                :rules="agile.fieldRules.prefixRules"
                                outlined
                                dense
                                
                            ></v-text-field>
                        </v-col>

                        
                    </v-row>


                    <v-row no-gutters>

                        <v-col align="right">
                            <v-btn color="iconTextColor" style="text-transform: none;" class="mr-3" small text router to="/admin/projects">
                                <v-icon medium class="pr-1">mdi-cancel</v-icon>
                                Cancel
                            </v-btn>
                            <v-btn color="iconTextColor" style="text-transform: none;" class="mr-3" small text @click="createProject">
                                <v-icon medium class="pr-1">mdi-check-bold</v-icon>
                                Create project
                            </v-btn>
                        </v-col>
                        
                    </v-row>

                </v-col>

            </v-row>

            </v-form>

        </v-container>
    </v-card>

</template>




<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from '@/shift/agile';
import agileFb from '@/shift/agileFb';
import fb from '@/shift/fb';


export default
{
    name: 'NewProject',

    // ----------------------------------
	//	VUE: Data and computed
	// ----------------------------------

	data: () =>
	({
		clients: [],
        groups: [],
        group: {},
        
        projectData:
        {
            name: '',
            variable: '',
            prefix: '',
            groupId: '',
        },

        isPropagating: false,

	}),

    computed:
	{
        // Get agile for the field rules (for validating)
        agile()
        {
            return agile;
        },
    },


    // ----------------------------------
	//	VUE: Watching things
    // ----------------------------------
    
    watch:
    {
        // ----------------------------------
        //	Check if groups got its clients updated
        // ----------------------------------
    
        clients: function()
        {
            if (!this.isPropagating) this.propagateGroupsWithClientName();
        }
    },

    // ----------------------------------------------------
    //
    //  VUE: Create and Mount
    //
    // ----------------------------------------------------
    
    created()
    {
        this.loadGroups();
        this.loadClients();
    },

	mounted()
	{
		
	},


	// --------------------------------------------------------------------
    //
    //	VUE: Methods
    //
	// --------------------------------------------------------------------
    
	methods:
	{

        // ----------------------------------
        //	Load client list and let it
        //  live reload!
        // ----------------------------------

        loadClients()
        {
            
            
            fb.db.collection('clients').onSnapshot(res =>
            {
                const changes = res.docChanges();

                changes.forEach(change =>
                {

                    // ----------------------------------
                    //	Content added
                    // ----------------------------------

                    if (change.type === 'added')
                    {
                        this.clients.push(
                        {
                            ...change.doc.data(),
                            id: change.doc.id
                        })
                    }


                    // ----------------------------------
                    //	Content modified
                    // ----------------------------------

                    if (change.type === "modified")
                    {
                        for (let i = 0; i < this.clients.length; i++)
                        {
                            if (this.clients[i].id == change.doc.id)
                            {
                                var uD = change.doc.data();
                                this.clients[i].name = uD.name;
                                this.clients[i].variable = uD.variable;
                                this.clients[i].prefix = uD.prefix;
                                this.clients[i].id = change.doc.id;
                            }
                        }
                    }


                    // ----------------------------------
                    //	Content deleted
                    // ----------------------------------

                    if (change.type === "removed")
                    {
                        for (let i = 0; i < this.clients.length; i++)
                        {
                            if (this.clients[i].id == change.doc.id)
                            {
                                this.clients.splice(i, 1);
                            }
                        }
                    } 
                });

            },
            er =>
            {
                this.$root.$alert("Error", er.message);
            });
        },



        // ----------------------------------
        //	Load group list and let it
        //  live reload!
        // ----------------------------------

        loadGroups()
        {
            fb.db.collection('project-groups').onSnapshot(res =>
            {
                const changes = res.docChanges();

                changes.forEach(change =>
                {

                    // ----------------------------------
                    //	Content added
                    // ----------------------------------

                    if (change.type === 'added')
                    {
                        this.groups.push(
                        {
                            ...change.doc.data(),
                            id: change.doc.id
                        })
                    }


                    // ----------------------------------
                    //	Content modified
                    // ----------------------------------

                    if (change.type === "modified")
                    {
                        for (let i = 0; i < this.groups.length; i++)
                        {
                            if (this.groups[i].id == change.doc.id)
                            {
                                var uD = change.doc.data();
                                this.groups[i].name = uD.name;
                                this.groups[i].variable = uD.variable;
                                this.groups[i].prefix = uD.prefix;
                                this.groups[i].id = change.doc.id;
                            }
                        }
                    }


                    // ----------------------------------
                    //	Content deleted
                    // ----------------------------------

                    if (change.type === "removed")
                    {
                        for (let i = 0; i < this.groups.length; i++)
                        {
                            if (this.groups[i].id == change.doc.id)
                            {
                                this.groups.splice(i, 1);
                            }
                        }
                    } 
                });

            },
            er =>
            {
                this.$root.$alert("Error", er.message);
            });
        },


        // ----------------------------------
        //	Create project
        // ----------------------------------

        createProject()
        {
            if (this.validate())
            {
                
                /* console.log(this.group);

                let a = "b";
                if (a == "b") return; */

                this.$root.ai_app.showProgressWheel = true;

                let clientPrefix = this.group.clientPrefix;
                let groupPrefix = this.group.prefix;

                // We want the client prefix when we create project
                /* for (let i = 0; i < this.groups.length; i++)
                {
                    if (this.projectData.groupId == this.groups[i].id)
                    {
                        clientPrefix = this.groups[i].clientPrefix;
                        groupPrefix = this.groups[i].prefix;
                    }
                } */
                
                
                
                // ----------------------------------
                //	Create project in Firebase
                // ----------------------------------

                fb.db.collection("projects").add(
				{
                    name: this.projectData.name,
                    disabled: false,
                    variable: this.projectData.variable,
                    groupId: this.group.id,
                    groupName: this.group.name,
                    clientId: this.group.clientId,
                    clientName: this.group.clientName,
                    key: clientPrefix+"-"+groupPrefix+"-"+this.projectData.prefix.toLowerCase(),
                    prefix: this.projectData.prefix.toLowerCase(),
                    accessMap:
                    {
                        master: clientPrefix,
                        group: groupPrefix,
                        project: this.projectData.prefix.toLowerCase()
                    }
				})
                .then(() =>
                {
                    this.$root.ai_app.snackbarText = 'Project created';
                    this.$root.ai_app.snackbarTimeout = 3000;
                    this.$root.ai_app.snackbar = true;
                    this.$root.ai_app.showProgressWheel = false;

                    // Update security rules for path to project
                    agileFb.updateSecurityRules();
                    agileFb.updateUsersAccessCards();
                    
                    this.$router.push('/admin/projects');
                })
                .catch((error) =>
                {
                    this.$root.ai_app.showProgressWheel = false;
                    this.$root.$alert("Error", error.message);
                });

            }
            
        },



        // ----------------------------------
        //	Put client nameinto group list
        // ----------------------------------

        propagateGroupsWithClientName()
        {
            for (let i = 0; i < this.groups.length; i++)
            {
                for (let j = 0; j < this.clients.length; j++)
                {
                    if (this.groups[i].clientId == this.clients[j].id)
                    {
                        this.groups[i].tempName = this.clients[j].name+" "+this.groups[i].name;
                        this.groups[i].clientPrefix = this.clients[j].prefix;
                        this.groups[i].clientName = this.clients[j].name;
                        this.groups[i].clientId = this.clients[j].id;
                    }
                }
            }

            this.agile.sortBy(this.groups, 'tempName');

        },



        // ----------------------------------
        //	Form validation
        // ----------------------------------
        
        validate()
        {
            this.projectData.prefix = this.projectData.prefix.toLowerCase();
            return this.$refs.newProjectForm.validate();
        },

        resetValidation()
        {
            this.$refs.newProjectForm.resetValidation();
        },

	},



	// ----------------------------------
	//	VUE: Components
	// ----------------------------------

    components:
    {
        
    }

}
</script>